/**
 * Created by Ning Jiang on 1/8/2020.
 */

import {MultiSprites} from "@nolimitcity/slot-game/bin/core/displayobject/MultiSprites";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {TimelineLite, TweenLite} from "gsap";
import {Emitter} from "pixi-particles";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";
import {DeadwoodInitialWinCountUp} from "../../winpresentation/initial/DeadwoodInitialWinCountUp";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";

export class DeadwoodFreespinOutroView extends ScreenView {

    private _particleConfig:any = {
        "alpha" : {
            "start" : 0.7,
            "end" : 0.7
        },
        "scale" : {
            "start" : 0.7,
            "end" : 1.2,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 30,
            "end" : 0,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : 0
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 200
        },
        "lifetime" : {
            "min" : 8,
            "max" : 10
        },
        "blendMode" : "add",
        "frequency" : 0.8,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : true,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -180,
            "y" : 0,
            "w" : 200,
            "h" : 0
        }
    };
    private _totalWinStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : 48,
        fontWeight : FontWeight.BOLD,
        align : "center",
        dropShadow : true,
        dropShadowAlpha : 0.6,
        dropShadowAngle : 89.5,
        dropShadowBlur : 6,
        dropShadowColor : "#1a1740",
        dropShadowDistance : 3,
        fill : [
            "#fff7e8",
            "#fffdec",
            "#fff0aa",
            "#ffc733"
        ],
        miterLimit : 7,
        stroke : "#bd1e96",
        strokeThickness : 1
    };

    private _spinsPlayedStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : 30,
        fontWeight : FontWeight.NORMAL,
        align : "center",
        dropShadow : true,
        dropShadowAlpha : 0.6,
        dropShadowAngle : 89.5,
        dropShadowBlur : 6,
        dropShadowColor : "#1a1740",
        dropShadowDistance : 3,
        fill : 0xfff7e8,
        miterLimit : 7
    };

    private _totalWinText:PIXI.Text;
    private _spinsPlayed:PIXI.Text;
    private _textContainer:PIXI.Container;
    private _totalWinCountUp:DeadwoodInitialWinCountUp;
    private _featureSprite:MultiSprites;
    private _shootOut:PIXI.Sprite;
    private _bigGlow:PIXI.Sprite;
    private _smallGlow:PIXI.Sprite;
    private _noWinSprite:PIXI.Sprite;
    private _emitter:Emitter;

    private _isNoWin:boolean = false;

    // #369
    public _winBelowStake:boolean = false;

    constructor(config:IScreenViewConfig, autoClose:boolean = false) {
        super(config, autoClose);
        this._totalWinCountUp = new DeadwoodInitialWinCountUp(true);
    }

    protected createBackground():PIXI.DisplayObject {
        return new PIXI.Graphics();
    }

    protected onResizeBackground(data:IResizeData):void {
        const bg:PIXI.Graphics = <PIXI.Graphics>this._background;
        bg.clear();
        bg.beginFill(0x000000, 0.85);
        bg.drawRect(0, 0, this._screenWidth, this._screenHeight)
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._bigGlow = new PIXI.Sprite(GameResources.getTextures("outroGlow")[0]);
        this._bigGlow.blendMode = PIXI.BLEND_MODES.ADD;
        this._bigGlow.anchor.set(0.6, 0.5);
        this._bigGlow.scale.set(2);
        this._bigGlow.alpha = 0;
        this.addChild(this._bigGlow);

        this._featureSprite = new MultiSprites({
            "1" : {
                textures : GameResources.getTextures("fsOutroFeature1"),
                anchor : [0.5, 0.5]
            },
            "2" : {
                textures : GameResources.getTextures("fsOutroFeature2"),
                anchor : [0.5, 0.5]
            }
        });
        this._featureSprite.alpha = 0;
        this.addChild(this._featureSprite);

        this._shootOut = new PIXI.Sprite(GameResources.getTextures("shootOutText")[0]);
        this._shootOut.anchor.set(0.5);
        this._shootOut.scale.set(0.5);
        this._shootOut.rotation = -0.25;
        this._shootOut.alpha = 0;
        this.addChild(this._shootOut);

        this._textContainer = new PIXI.Container();

        this._noWinSprite = new PIXI.Sprite(GameResources.getTextures("fsOutroNoWin")[0]);
        this._noWinSprite.anchor.set(0.5, 0.58);
        this._noWinSprite.scale.set(0.8);
        this._noWinSprite.alpha = 0;
        this._textContainer.addChild(this._noWinSprite);

        this._totalWinText = new PIXI.Text(Translation.translate("TOTAL WIN"), this._totalWinStyle);
        this._totalWinText.anchor.set(0.5);
        this._totalWinText.position.set(0, -200);
        this._totalWinText.alpha = 0;
        this._textContainer.addChild(this._totalWinText);

        this._spinsPlayed = new PIXI.Text("", this._spinsPlayedStyle);
        this._spinsPlayed.anchor.set(0.5);
        this._spinsPlayed.position.set(0, 120);
        this._spinsPlayed.alpha = 0;
        this._textContainer.addChild(this._spinsPlayed);

        this._smallGlow = new PIXI.Sprite(GameResources.getTextures("outroGlow")[0]);
        this._smallGlow.blendMode = PIXI.BLEND_MODES.ADD;
        this._smallGlow.anchor.set(0.45, 0.7);
        this._smallGlow.scale.set(1.34, 0.78);
        this._smallGlow.alpha = 0;
        this._textContainer.addChild(this._smallGlow);

        this._totalWinCountUp.position.set(0, 0);
        this._totalWinCountUp.alpha = 0;
        this._textContainer.addChild(this._totalWinCountUp);

        return this._textContainer;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._bigGlow.position.set(this._screenWidth * 0.6, this._screenHeight * 0.5);
        this._textContainer.position.set(this._screenWidth * 0.6, this._screenHeight * 0.5);
        this._featureSprite.position.set(this._screenWidth * 0.35, this._screenHeight * 0.5);
        this._shootOut.position.set(this._featureSprite.x - 100, this._featureSprite.y + 100);
    }

    public show(data?:DeadwoodParsedGameData, onShowComplete?:() => void):void {
        const win:number = data?.accumulatedRoundWin != undefined ? parseFloat(data?.accumulatedRoundWin) : 0;
        this._winBelowStake = BelowStakeWinRestriction.isWinBelowStake(win, (<ParsedGameData>data).playedBetValue);
        this._isNoWin = (data!.totalWin === 0);
        // this._isNoWin = true;
        super.show(data, onShowComplete);
    }

    protected startPresentation(data?:DeadwoodParsedGameData, onShowComplete?:() => void):void {

        // TODO: add new ontario below stake behaviour for sound and countup

        this._spinsPlayed.text = `${Translation.translate("Spins Played:")} ${data!.numberOfFreespinsPlayed!.toString()}`;
        this._button.alpha = 0;
        if(!this._emitter) {
            this._emitter = new Emitter(this._bigGlow, GameResources.getTextures("fsintroParticle"), this._particleConfig);
            ParticlesManager.addEmitter(this._emitter);
        }
        this._emitter.emit = true;
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            TweenLite.fromTo(this._background, 0.5, {alpha : 0}, {alpha : 1}),
            TweenLite.to(this._bigGlow, 0.3, {alpha : 1}),
            this._featureSprite.playSprite(data!.playerFSSelection.toString(),
                // this._featureSprite.playSprite("1",
                {duration : 0.4, vars : [{toVars : {alpha : 1}}]},
                {duration : 0, vars : [{toVars : {alpha : 0}}]}),
            TweenLite.to(this._featureSprite, 0.5, {alpha : 1, delay : 0.4})
        ]);
        if(this._isNoWin) {
            timeline.add(TweenLite.to(this._noWinSprite, 0.3, {alpha : 1}), 0);
        } else {
            // #369
            const countUpDuration:number = this._winBelowStake ? 0 : 1;

            timeline.add([
                TweenLite.to(this._smallGlow, 0.2, {alpha : 0.75}),
                TweenLite.to(this._totalWinCountUp, 0.2, {alpha : 1}),
                TweenLite.fromTo(this._totalWinCountUp.scale, countUpDuration, {x : 0.9, y : 0.9}, {x : 1, y : 1}),
                this._totalWinCountUp.getCountUpAnimation(0, data!.totalWin, countUpDuration, 1, this._winBelowStake),
                // this._totalWinCountUp.getCountUpAnimation(0, 1000, 1, 1),
                (!this._winBelowStake) ? TweenLite.to(this._totalWinText, 0.2, {alpha : 1}) : () => {}
            ], 0);
        }
        if(data!.fsSuperModeActive) {
            // if(true) {
            timeline.add([
                TweenLite.to(this._shootOut, 0.3, {alpha : 1}),
                TweenLite.fromTo(this._shootOut.scale, 0.4, {x : 1, y : 1}, {x : 0.5, y : 0.5})
            ], 0.5);
        }
        timeline.add([
            TweenLite.to(this._spinsPlayed, 0.12, {alpha : 1}),
            TweenLite.to(this._button, 0.22, {alpha : 1})
        ], timeline.totalDuration() - 0.2);
        timeline.add(() => super.startPresentation(data, onShowComplete));
    }

    protected stopPresentation(closeCallback?:() => void):void {
        if(this._emitter) {
            this._emitter.emit = false;
        }

        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            TweenLite.to(this._button, 0.2, {alpha : 0}),
            TweenLite.to(this._totalWinText, 1, {alpha : 0}),
            TweenLite.to(this._totalWinCountUp, 1, {alpha : 0}),
            TweenLite.to(this._smallGlow, 0.8, {alpha : 0}),
            TweenLite.to(this._spinsPlayed, 0.6, {alpha : 0}),
            TweenLite.to(this._featureSprite, 0.6, {alpha : 0}),
            TweenLite.to(this._shootOut, 0.6, {alpha : 0}),
            TweenLite.to(this._bigGlow, 0.6, {alpha : 0}),
            TweenLite.to(this._noWinSprite, 0.6, {alpha : 0}),
            TweenLite.to(this._background, 1.5, {alpha : 0})
        ]);
        timeline.add(() => {
            super.stopPresentation(closeCallback)
        });
    }
}